import * as React from 'react';
import { ITrackType, ClickstreamAnalyticsProvider } from '@shared-ui/clickstream-analytics-context';
import { PlatformAnalyticsStore } from 'bernie-analytics';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

/**
 * BEX (UIS-Prime) implementation of IClickstreamAnalytics interface
 */
var UisPrimeClickstream = /** @class */ (function () {
    function UisPrimeClickstream() {
        this.track = this.track.bind(this);
        this.reset = this.reset.bind(this);
    }
    UisPrimeClickstream.prototype.track = function (type, options) {
        if (type === ITrackType.EVENT) {
            this.trackEvent(options.data, options.config);
        }
    };
    UisPrimeClickstream.prototype.reset = function () {
        PlatformAnalyticsStore.resetAnalyticsForNewPage();
    };
    UisPrimeClickstream.prototype.trackEvent = function (data, config) {
        if (config && config.delay) {
            setTimeout(function () {
                PlatformAnalyticsStore.getPlatformAnalytics().trackEvent(data);
            }, 0);
        }
        else {
            PlatformAnalyticsStore.getPlatformAnalytics().trackEvent(data);
        }
    };
    return UisPrimeClickstream;
}());
var createUisPrimeClickstream = function () { return new UisPrimeClickstream(); };

var isServer = function () { return typeof window === 'undefined'; };

var egClickstreamSdkNoop = {
    publish: function () { },
    updateContext: function () { },
};
var egClickstreamSdkInstance;
var getCallbacks = function (logger) {
    return {
        onFetchError: function (error) {
            logger === null || logger === void 0 ? void 0 : logger.info('EGCS_FETCH_ERROR', "EGCS failed on fetch. ".concat(error));
        },
        onInvalidPayload: function (error) {
            logger === null || logger === void 0 ? void 0 : logger.info('EGCS_INVALID_PAYLOAD', "EGCS failed due to invalid payload. ".concat(error));
        },
        onPublishError: function (error) {
            logger === null || logger === void 0 ? void 0 : logger.info('EGCS_PUBLISH_ERROR', "EGCS failed on publish. ".concat(error));
        },
    };
};
var getNewInstance = function (options) {
    var sdk = require('eg-clickstream-sdk-js');
    var callbacks = getCallbacks(options === null || options === void 0 ? void 0 : options.logger);
    return sdk.instance && sdk.instance.getNewInstance(callbacks, options === null || options === void 0 ? void 0 : options.egClickstream);
};
/**
 * Creates and returns a new instance of EgClickstreamSdk
 */
var createEgClickstreamSdkInstance = function (options) {
    return isServer() ? egClickstreamSdkNoop : getNewInstance(options);
};
/**
 * Gets the instance of singleton EgClickstreamSdk class
 */
var getEgClickstreamSdkInstance = function (options) {
    if (!egClickstreamSdkInstance) {
        egClickstreamSdkInstance = createEgClickstreamSdkInstance(options);
    }
    return egClickstreamSdkInstance;
};

/**
 * The implementation of EgClickstreamService interface
 */
var EgClickstreamServiceImpl = /** @class */ (function () {
    function EgClickstreamServiceImpl(options) {
        this.egClickstreamSdkInstance = getEgClickstreamSdkInstance(options);
    }
    EgClickstreamServiceImpl.prototype.publish = function (data) {
        if (this.egClickstreamSdkInstance) {
            this.egClickstreamSdkInstance.publish(data);
        }
    };
    EgClickstreamServiceImpl.prototype.updateContext = function (data) {
        if (this.egClickstreamSdkInstance) {
            this.egClickstreamSdkInstance.updateContext(data);
        }
    };
    return EgClickstreamServiceImpl;
}());
var createEgClickstreamService = function (options) { return new EgClickstreamServiceImpl(options); };

/**
 * EG-Clickstream implementation of IClickstreamAnalytics interface
 */
var EgClickstream = /** @class */ (function () {
    function EgClickstream(options) {
        this.egClickstreamService = createEgClickstreamService(options);
        this.track = this.track.bind(this);
        this.reset = this.reset.bind(this);
    }
    EgClickstream.prototype.track = function (type, options) {
        var _this = this;
        var data = options.data;
        if (!Array.isArray(data)) {
            data = [data];
        }
        if (type === ITrackType.EVENT) {
            data.forEach(function (item) {
                _this.egClickstreamService.publish(item);
            });
        }
    };
    EgClickstream.prototype.reset = function (options) {
        var data = options && options.data;
        if (data) {
            this.egClickstreamService.updateContext(data);
        }
    };
    return EgClickstream;
}());
var createEgClickstream = function (options) { return new EgClickstream(options); };

var clickstreamMap = {
    'uis-prime': createUisPrimeClickstream,
};
/**
 * The implementation of IClickstreamAnalytics interface
 */
var Clickstream = /** @class */ (function () {
    function Clickstream(options) {
        this.setBrandClickstream(options);
        this.egClickstream = createEgClickstream(options);
        this.track = this.track.bind(this);
        this.reset = this.reset.bind(this);
    }
    Clickstream.prototype.track = function (type, options) {
        this.getClickstreamObject(options).track(type, options);
    };
    Clickstream.prototype.reset = function (options) {
        this.getClickstreamObject(options).reset(options);
    };
    /**
     * Gets brand specific or EG clickstream object based on the provided options
     * Returns egClickstream if the value of options.config.isEgClickstream is true
     */
    Clickstream.prototype.getClickstreamObject = function (options) {
        var clickstreamObject = this.brandClickstream;
        if (options && options.config && options.config.isEgClickstream === true) {
            clickstreamObject = this.egClickstream;
        }
        return clickstreamObject;
    };
    /**
     * Sets brandClickstream to the clickstream object that matches the provided name
     * and uses brandClickstreamNoop if no match found
     * @param config
     */
    Clickstream.prototype.setBrandClickstream = function (options) {
        var brandClickstreamNoop = {
            track: function () { },
            reset: function () { },
        };
        var brandClickstreamFactory = clickstreamMap[options === null || options === void 0 ? void 0 : options.brandClickstream];
        this.brandClickstream = brandClickstreamFactory ? brandClickstreamFactory() : brandClickstreamNoop;
    };
    return Clickstream;
}());
var createClickstream = function (options) { return new Clickstream(options); };

function getClickstreamAnalytics(options) {
    return createClickstream(options);
}

function ClickstreamPlugin(pluginOptions) {
    return {
        name: 'clickstream',
        onBrowserHydrateRenderContext: function (context, next) {
            var hydratedState = context.hydratedState, setAppData = context.setAppData, getAppData = context.getAppData;
            var clickstreamHydratedState = hydratedState === null || hydratedState === void 0 ? void 0 : hydratedState.clickstreamOptions;
            var logger = getAppData().logger;
            setAppData({
                clickstreamAnalytics: getClickstreamAnalytics(__assign(__assign(__assign({}, pluginOptions), clickstreamHydratedState), { logger: logger })),
            });
            return next(context);
        },
        onBrowserWrapRootElement: function (context, next) {
            var getAppData = context.getAppData, setRootElement = context.setRootElement;
            var clickstreamAnalytics = getAppData().clickstreamAnalytics;
            setRootElement(function (RootElement) { return function (props) { return (React.createElement(ClickstreamAnalyticsProvider, { clickstreamAnalytics: clickstreamAnalytics },
                React.createElement(RootElement, null, props.children))); }; });
            return next(context);
        },
    };
}

export { ClickstreamPlugin as default };
//# sourceMappingURL=browser.js.map
